export const SIGN_SEGMENT_FROM_MAP_STATE = 'signSegmentFromMap';
